import classnames from 'classnames';

interface SeparatorProps {
  width: string;
  noMarginTop?: boolean;
  white?: boolean;
}

export const Separator = ({ width, noMarginTop, white }: SeparatorProps) => (
  <div
    className={classnames(
      'border border-border_balance_sidebar',
      noMarginTop ? 'mt-0' : 'mt-5',
      width,
      {
        'border-text-2': Boolean(white)
      }
    )}
  />
);
